@if(superAdminProfile){
  <mat-card class="profile-card">
    <mat-card-content>

      @if(!isEditingSuperAdminProfile){
        <!-- VIEW MODE -->
        <div class="profile-header">
          <div class="profile-avatar">
            <mat-icon>admin_panel_settings</mat-icon>
          </div>
          <div class="profile-header-text">
            <h2>{{ superAdminProfile.fullName }}</h2>
            <span class="profile-role-badge">Super Admin</span>
          </div>
          <button mat-icon-button (click)="startEditingSuperAdminProfile()" aria-label="Edit profile">
            <mat-icon>edit</mat-icon>
          </button>
        </div>

        <mat-divider></mat-divider>

        <div class="profile-details">
          <div class="profile-detail-row">
            <mat-icon>email</mat-icon>
            <span>{{ superAdminProfile.email }}</span>
          </div>
          <div class="profile-detail-row">
            <mat-icon>phone</mat-icon>
            <span>{{ superAdminProfile.phoneNumber || 'Not provided' }}</span>
          </div>
          <div class="profile-detail-row">
            <mat-icon>verified_user</mat-icon>
            <span>{{ superAdminProfile.status }}</span>
          </div>
        </div>

        <mat-divider></mat-divider>

        <div class="profile-actions">
          <button mat-stroked-button color="primary" (click)="openChangePasswordModal()">
            <mat-icon>lock</mat-icon>
            Change Password
          </button>
        </div>

      } @else {
        <!-- EDIT MODE -->
        <h2 class="edit-title">Edit Profile</h2>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>First Name</mat-label>
          <input matInput [(ngModel)]="editFirstName" name="editFirstName" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Last Name</mat-label>
          <input matInput [(ngModel)]="editLastName" name="editLastName" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Phone Number</mat-label>
          <input matInput [(ngModel)]="editPhoneNumber" name="editPhoneNumber" />
        </mat-form-field>

        <div class="profile-actions">
          <button mat-button (click)="cancelEditingSuperAdminProfile()" [disabled]="isSavingSuperAdminProfile">
            Cancel
          </button>
          <button mat-raised-button color="primary"
                  (click)="saveSuperAdminProfile()"
                  [disabled]="isSavingSuperAdminProfile || !editFirstName.trim() || !editLastName.trim()">
            {{ isSavingSuperAdminProfile ? 'Saving...' : 'Save Changes' }}
          </button>
        </div>
      }

    </mat-card-content>
  </mat-card>
} @else if(profileData){
  @if (showHospitals) {
    <mat-tab-group>
      <mat-tab label="Profile">
        <app-patient-registration-details [inputData]="profileData" [practitionerPurpose]="true"
          (editRequested)="onEditRequested($event)">
        </app-patient-registration-details>
      </mat-tab>
      <mat-tab label="My hospitals">
        <app-my-hospitals></app-my-hospitals>
      </mat-tab>
    </mat-tab-group>
  } @else {
    <app-patient-registration-details [inputData]="profileData" [practitionerPurpose]="true"
      (editRequested)="onEditRequested($event)">
    </app-patient-registration-details>
  }
}